import React, { useCallback, useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router";
import { getVideoDetails } from "../../../api/functions/video.api";
import styles from "../../../styles/components/video.module.scss";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  Grid,
  List,
  ListItem,
  Slider,
  styled,
  Container,
} from "@mui/material";
import assest from "../../../json/assest";
import PerfectScrollbar from "react-perfect-scrollbar";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import SubmitterDetails from "../components/SubmitterDetails";

import { useNavigate } from "react-router-dom";
import ApiLoader from "../../Loaders/ApiLoader";
import CopyrightOwnerships from "../components/CopyrightOwnerships";
import {
  clipCopy,
  concatDownloadPath,
  concatHostAndImagePath,
  openInNewTab,
} from "../../../lib/functions/utils.lib";
import SubmissionInformation from "../components/SubmissionInformation";
import VideoDetailsPending from "../components/VideoDetailsPending";
import CustomVideoPlayer from "../components/CustomVideoPlayer";

const DeletedVideo = () => {
  const navigate = useNavigate();

  const { id } = useParams();

  const { data, isLoading } = useQuery(
    "pending_video",
    () => getVideoDetails(id),
    {
      enabled: id ? true : false,
    }
  );

  console.warn("del data", data);

  const [openThisYear, setOpenThisYear] = React.useState(false);
  const [openThisYear1, setOpenThisYear1] = React.useState(false);
  const [openThisYear2, setOpenThisYear2] = React.useState(false);
  const [openThisYear3, setOpenThisYear3] = React.useState(false);

  const handleToggleThisYear = () => {
    setOpenThisYear(!openThisYear);
  };

  const handleToggleThisYear1 = () => {
    setOpenThisYear1(!openThisYear1);
  };

  const handleToggleThisYear2 = () => {
    setOpenThisYear2(!openThisYear2);
  };

  const handleToggleThisYear3 = () => {
    setOpenThisYear3(!openThisYear3);
  };

  //   /***************modal1*****************/

  //   const [open, setOpen] = React.useState(false);
  //   const handleClickOpen = () => {
  //     setOpen(true);
  //   };
  //   const handleClose = () => {
  //     setOpen(false);
  //   };

  //   /***************modal2*****************/

  //   const [open1, setOpen1] = React.useState(false);
  //   const handleClickOpen1 = () => {
  //     setOpen1(true);
  //   };
  //   const handleClose1 = () => {
  //     setOpen1(false);
  //   };

  //   /***************modal3*****************/

  //   const [open2, setOpen2] = React.useState(false);
  //   const handleClickOpen2 = () => {
  //     setOpen2(true);
  //   };
  //   const handleClose2 = () => {
  //     setOpen2(false);
  //   };

  //   /***************approveModal*****************/

  const [openApprove, setOpenApprove] = React.useState(false);
  const handleClickOpenApprove = () => {
    setOpenApprove(true);
  };
  const handleCloseApprove = () => {
    setOpenApprove(false);
  };

  /***************ProceedModal*****************/

  const [openProceed, setOpenProceed] = React.useState(false);
  const handleClickOpenProceed = () => {
    setOpenProceed(true);
  };
  const handleCloseProceed = () => {
    setOpenProceed(false);
  };

  /***************DenydModal*****************/

  const [openDeny, setOpenDeny] = React.useState(false);
  const handleClickOpenDeny = () => {
    setOpenDeny(true);
  };
  const handleCloseDeny = () => {
    setOpenDeny(false);
  };

  /***************VideoReleasedModal*****************/

  const [openVideoRelease, setOpenVideoRelease] = React.useState(false);
  const handleClickOpenVideoRelease = () => {
    setOpenVideoRelease(true);
  };
  const handleCloseVideoRelease = () => {
    setOpenVideoRelease(false);
  };

  /*****************************release video modal***************************/

  const [openCopyRightDispute, setOpenCopyRightDispute] = React.useState(false);
  const handleClickOpenCopyRightDispute = () => {
    setOpenCopyRightDispute(true);
  };
  const handleCloseCopyRightDispute = () => {
    setOpenCopyRightDispute(false);
  };

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#fff",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 237,
      padding: "11px 13px",
      fontSize: theme.typography.pxToRem(12),
      boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.25)",
      borderRadius: "10px",
      height: "83px",
      margin: "0",
    },
  }));

  return (
    <Box className={styles.VideoPageScroll}>
      <ApiLoader loading={isLoading} />
      {data?.video && (
        <PerfectScrollbar>
          <Box className={styles.videoWrapper}>
            <Box className={styles.videoWrapperLeft}>
              <Box className="VideocommonBox">
                <Box className={styles.videoSection}>
                  <Box className={styles.videoBox}>
                    <CustomVideoPlayer data={data} />
                  </Box>

                  <Box className={styles.videoInput}>
                    <input
                      type="text"
                      disabled
                      placeholder={concatDownloadPath(data.video.video)}
                    />
                    <Button
                      onClick={() =>
                        clipCopy(concatDownloadPath(data.video.video))
                      }
                    >
                      <img
                        src={assest.copyIcon}
                        width={13}
                        height={16}
                        alt=""
                      />
                    </Button>
                  </Box>

                  <Box className={styles.btnWrapper}>
                    <Box className={styles.buttonGroup}>
                      <Button
                        className={`${styles.post}`}
                        onClick={handleClickOpenApprove}
                      >
                        <Box className={styles.disable}></Box>
                        <img
                          src={assest.postIcon}
                          width={14}
                          height={14}
                          alt=""
                        />{" "}
                        Approve
                      </Button>
                      {/* <Button className={`${styles.post}`}><Box className={styles.disable}></Box><img src={assest.postIcon} width={14} height={14} alt='' /> Post Everywhere</Button> */}
                      <Button className={`${styles.website}`}>
                        <Box className={styles.disable}></Box>
                        <img
                          src={assest.websiteIcon}
                          width={14}
                          height={14}
                          alt=""
                        />{" "}
                        Website Only
                      </Button>
                      <Button
                        className={`${styles.inquire}`}
                        onClick={handleClickOpenProceed}
                      >
                        <Box className={styles.disable}></Box>
                        <img
                          src={assest.inqureIcon}
                          width={14}
                          height={14}
                          alt=""
                        />{" "}
                        Inquire
                      </Button>
                      <Button
                        className={`${styles.reject}`}
                        onClick={handleClickOpenApprove}
                      >
                        <Box className={styles.disable}></Box>
                        <img
                          src={assest.crossBlackIcon}
                          width={14}
                          height={14}
                          alt=""
                        />{" "}
                        Reject
                      </Button>
                      <Button
                        className={`${styles.delete}`}
                        onClick={handleClickOpenApprove}
                      >
                        <Box className={styles.disable}></Box>
                        <img
                          src={assest.deleteIcon}
                          width={14}
                          height={14}
                          alt=""
                        />{" "}
                        Delete
                      </Button>
                    </Box>
                  </Box>

                  <Box className={styles.selectWrapper}>
                    <Box className={styles.tble_hdng}>
                      {openThisYear3 ? (
                        <Box className={styles.year_drop}>
                          <ul>
                            <li>
                              <Box className={styles.yearClose}>
                                Select a QC Agent to message
                                <CloseIcon />
                              </Box>
                            </li>
                            <li onClick={handleClickOpen}>Theodore Doulke</li>
                            <li onClick={handleClickOpen1}>Avraam Pedtirs</li>
                            <li>Avraam Pedtirs</li>
                            <li>Theodore Doulke</li>
                          </ul>
                        </Box>
                      ) : null}
                    </Box>

                    <Box className={styles.tble_hdng}>
                      <Button
                        onClick={handleToggleThisYear}
                        className={`${
                          openThisYear ? styles.active_drop : null
                        }`}
                      >
                        {openThisYear ? (
                          <img
                            src={assest.messageContentIcon}
                            width={14}
                            height={14}
                            alt=""
                          />
                        ) : (
                          <img
                            src={assest.messageContentIcon}
                            width={14}
                            height={14}
                            alt=""
                          />
                        )}
                        Message Content Buyer{" "}
                      </Button>

                      {openThisYear ? (
                        <Box className={styles.year_drop}>
                          <ul>
                            <li>
                              <Box className={styles.yearClose}>
                                Select a QC Agent to message
                                <CloseIcon />
                              </Box>
                            </li>
                            <li onClick={handleClickOpen}>Theodore Doulke</li>
                            <li onClick={handleClickOpen1}>Avraam Pedtirs</li>
                            <li>Avraam Pedtirs</li>
                            <li>Theodore Doulke</li>
                          </ul>
                        </Box>
                      ) : null}
                    </Box>

                    <Box className={styles.tble_hdng}>
                      <Button
                        onClick={handleToggleThisYear1}
                        className={`${
                          openThisYear1 ? styles.active_drop : null
                        }`}
                      >
                        {openThisYear1 ? (
                          <img
                            src={assest.messageContentIcon}
                            width={14}
                            height={14}
                            alt=""
                          />
                        ) : (
                          <img
                            src={assest.messageContentIcon}
                            width={14}
                            height={14}
                            alt=""
                          />
                        )}
                        Message QC Agent{" "}
                      </Button>

                      {openThisYear1 ? (
                        <Box className={styles.year_drop}>
                          <ul>
                            <li>
                              <Box className={styles.yearClose}>
                                Select a QC Agent to message
                                <CloseIcon />
                              </Box>
                            </li>
                            <li>Theodore Doulke</li>
                            <li>Avraam Pedtirs</li>
                            <li>Avraam Pedtirs</li>
                            <li>Theodore Doulke</li>
                          </ul>
                        </Box>
                      ) : null}
                    </Box>

                    <Box className={styles.tble_hdng}>
                      <Button
                        onClick={handleToggleThisYear2}
                        className={`${
                          openThisYear2 ? styles.active_drop : null
                        }`}
                      >
                        {openThisYear2 ? (
                          <img
                            src={assest.messageContentIcon}
                            width={14}
                            height={14}
                            alt=""
                          />
                        ) : (
                          <img
                            src={assest.messageContentIcon}
                            width={14}
                            height={14}
                            alt=""
                          />
                        )}
                        Message Manager{" "}
                      </Button>

                      {openThisYear2 ? (
                        <Box className={styles.year_drop}>
                          <ul>
                            <li>
                              <Box className={styles.yearClose}>
                                Select a QC Agent to message
                                <CloseIcon />
                              </Box>
                            </li>
                            <li>Theodore Doulke</li>
                            <li>Avraam Pedtirs</li>
                            <li>Avraam Pedtirs</li>
                            <li>Theodore Doulke</li>
                          </ul>
                        </Box>
                      ) : null}
                    </Box>
                  </Box>

                  <Box className={styles.downloadButton}>
                    <Button
                      onClick={() =>
                        openInNewTab(concatDownloadPath(data.video.video))
                      }
                    >
                      <img
                        src={assest.doenloadVideoicon}
                        width={13}
                        height={14}
                        alt=""
                      />{" "}
                      Download Video
                    </Button>
                    <Button>
                      <img
                        src={assest.downloadAssignment}
                        width={14}
                        height={14}
                        alt=""
                      />{" "}
                      Download Redacted Agreement
                    </Button>
                  </Box>
                </Box>
              </Box>
              <VideoDetailsPending data={data?.video} />
            </Box>

            <Box className={styles.videoWraperRight}>
              <PerfectScrollbar>
                <Box className={styles.videoOwner}>
                  <Box
                    className={`${styles.approveBox} ${styles.approveOrangeBox}`}
                  >
                    <p>
                      This video is <b>pending</b> review
                    </p>
                    <Box className={styles.crossButton}>
                      <Button onClick={() => navigate("/pending")}>
                        <img
                          src={assest.crossBlack}
                          width={21}
                          height={21}
                          alt=""
                        />
                      </Button>
                    </Box>
                  </Box>

                  <SubmitterDetails data={data?.video} />
                  <CopyrightOwnerships data={data?.video} />
                </Box>
              </PerfectScrollbar>
              <SubmissionInformation data={data?.video} />
            </Box>
          </Box>
        </PerfectScrollbar>
      )}
    </Box>
  );
};

export default DeletedVideo;
